import { IState } from '../../store';

export const selectorEntryToShowEnabled = (state: IState) => state.entryToShowEnabled;
